// This file was automatically generated from appchart.dialog.reconcileCdaImport.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.reconcileCdaImport');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.reconcileCdaImport.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><h4 class="el8SectionHeaderNoMargin mt10">Active ', (soy.$$escapeHtml(opt_data.sectionName)? soy.$$escapeHtml(opt_data.sectionName).capitalize() : ''), '</h4>');
  var itemList2555 = opt_data.activeList;
  var itemListLen2555 = itemList2555.length;
  if (itemListLen2555 > 0) {
    for (var itemIndex2555 = 0; itemIndex2555 < itemListLen2555; itemIndex2555++) {
      var itemData2555 = itemList2555[itemIndex2555];
      if (opt_data.sectionName == 'medications') {
        el8.template.appchart.dialog.reconcileCdaImport.medEntry(itemData2555, output);
      } else {
        el8.template.appchart.dialog.reconcileCdaImport.entry(soy.$$augmentData(itemData2555, {sectionName: opt_data.sectionName}), output);
      }
    }
  } else {
    output.append('<p class="el8SectionEmpty">None documented</p>');
  }
  output.append('<h4 class="el8SectionHeaderNoMargin mt20">');
  switch (opt_data.sectionName) {
    case 'medications':
      output.append('Discontinued');
      break;
    case 'allergies':
      output.append('Inactive');
      break;
    case 'problems':
      output.append('Resolved');
      break;
    case 'immunizations':
      output.append('Declined');
      break;
  }
  output.append(' ', (soy.$$escapeHtml(opt_data.sectionName)? soy.$$escapeHtml(opt_data.sectionName).capitalize() : ''), '</h4>');
  var itemList2579 = opt_data.inactiveList;
  var itemListLen2579 = itemList2579.length;
  if (itemListLen2579 > 0) {
    for (var itemIndex2579 = 0; itemIndex2579 < itemListLen2579; itemIndex2579++) {
      var itemData2579 = itemList2579[itemIndex2579];
      if (opt_data.sectionName == 'medications') {
        el8.template.appchart.dialog.reconcileCdaImport.medEntry(soy.$$augmentData(itemData2579, {inactive: true}), output);
      } else {
        el8.template.appchart.dialog.reconcileCdaImport.entry(soy.$$augmentData(itemData2579, {sectionName: opt_data.sectionName, inactive: true}), output);
      }
    }
  } else {
    output.append('<p class="el8SectionEmpty">None documented</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.reconcileCdaImport.entry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TableListContainer', (opt_data.index != undefined) ? ' importable-div el8BlueHighlightList' : '', '"><div class="el8TableListItem', (opt_data.index == undefined) ? ' el8ImportInChart ' : ' el8Clickable', '">', (opt_data.index != undefined) ? '<input type="checkbox" data-index="' + soy.$$escapeHtml(opt_data.index) + '" class="importable-checkbox" checked></input>' : '', soy.$$escapeHtml(opt_data.description), (opt_data.sectionName == 'immunizations' && opt_data.startDate) ? '<span class="ml5 el8SystemText">administered ' + (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') + '</span>' : (opt_data.endDate) ? '<span class="ml5 el8SystemText">resolved on ' + (soy.$$escapeHtml(opt_data.endDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.endDate)) : '') + '</span>' : (opt_data.declinedDate) ? '<span class="ml5 el8SystemText">declined on ' + (soy.$$escapeHtml(opt_data.declinedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.declinedDate)) : '') + '</span>' : (opt_data.inactive) ? '<span class="ml5 el8SystemText">inactive</span>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.reconcileCdaImport.medEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TableListContainer', (opt_data.index != undefined) ? ' importable-div el8BlueHighlightList' : '', '">', (opt_data.index == undefined && opt_data.activeOrderId) ? '<div class="fr"><button type="button" class="el8button dc-med-trigger el8ItemButton2" data-id="' + soy.$$escapeHtml(opt_data.activeOrderId) + '">D/C</button></div>' : '', '<div class="el8TableListItem', (opt_data.index == undefined) ? ' el8ImportInChart ' : ' el8Clickable', '">', (opt_data.index != undefined) ? '<input type="checkbox" data-index="' + soy.$$escapeHtml(opt_data.index) + '" class="importable-checkbox" checked></input>' : '', soy.$$escapeHtml(opt_data.description), (opt_data.endDate) ? '<span class="ml5 el8SystemText">discontinued on ' + (soy.$$escapeHtml(opt_data.endDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.endDate)) : '') + '</span>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};
